import jwt_decode from "jwt-decode";
import {storageFactory} from './helpers/storage';
const local = storageFactory(() => localStorage);

export const adminDomains = ['wkit.black-sheep.ru', 'construct-bs.comdi.com', 'webinar.black-sheep.ru'];
export const userHost =
  process.env.NODE_ENV === 'development' ? 'https://broadcast.black-sheep.ru' : `https://${window.location.hostname}`;
const adminHost =
  process.env.NODE_ENV === 'development' ? `https://${adminDomains[0]}` : `https://${window.location.hostname}`;
// const settingsHost =
//   process.env.NODE_ENV === 'development' ? 'https://wkit.black-sheep.ru' : `https://${window.location.hostname}`;

// const userHost = 'https://broadcast.black-sheep.ru';
// const userHost = 'https://wkit.black-sheep.ru';
// const adminHost = 'https://webinar.black-sheep.ru';

const fetchOptions = {
  mode: 'cors',
  headers: {}
};

if (process.env.NODE_ENV === 'development') {
  fetchOptions.credentials = 'include'
}

const tokenStorageKey = (eventKey) => eventKey ? `client_access_token_${eventKey}` : 'client_access_token';
const tokenHeaderName = 'x-client-access-token';

const setRequestToken = (eventKey) => {
  fetchOptions.headers = {};
  const token = local.getItem(tokenStorageKey(eventKey)) ? local.getItem(tokenStorageKey(eventKey)) : local.getItem(tokenStorageKey());
  if (token) {
    fetchOptions.headers = {'x-client-access-token': token}; 
  }
};

const saveRequestToken = (api_resp, eventKey) => {
  const token = api_resp.headers.get(tokenHeaderName);
    
  if (token) {
    if (token === "~") {
      local.removeItem(tokenStorageKey(eventKey));
    } else {
      const decodedJwt = jwt_decode(token);
      if (decodedJwt.hasOwnProperty('client')) {
        local.setItem(tokenStorageKey(eventKey), token)
      } else {
        local.setItem(tokenStorageKey(), token)
      }
    }
  }
};

export const checkAuthorization = async (eventKey) => {
  if (eventKey) {
    // const url = new URL(`${userHost}/broadcast/api/client/registration.json`);
    const url = new URL(`${userHost}/api/player/client/registration`);
    
    const params = { eventKey };
    url.search = new URLSearchParams(params).toString();
    setRequestToken(eventKey);

    try {
      const res = await fetch(url, fetchOptions);
      saveRequestToken(res, eventKey);
      return res;
    } catch (error) {
      return error;
    }
  }
  return false;
};

export const getEventRegistrationFields = async (eventKey) => {
  // const url = new URL(`${userHost}/api/player/event/${eventKey}`);
  const url = new URL(`${userHost}/api/player/event/${eventKey}`);
  try {
    const response = await fetch(url, fetchOptions);
    return await response.json();
  } catch (error) {
    return error;
  }
};

export const getUserInfo = async (eventKey) => {
  // const url = new URL(`${userHost}/broadcast/api/client.json`);
  const url = new URL(`${userHost}/api/player/event/${eventKey}/login`);
  
  setRequestToken(eventKey);
  try {
    const response = await fetch(url, fetchOptions);
    saveRequestToken(response, eventKey);
    return response.json();
  } catch (error) {
    return error;
  }
};

export const checkRegistrationByEmail = async (email, eventKey) => {
  const formData = new FormData();
  formData.append('email', email);
  formData.append('eventKey', eventKey);
  formData.append('locale', local.getItem(`userCurrentLocale${eventKey}`));

  // const url = new URL(`${userHost}/broadcast/api/client/account/comdi/check_email.json`);
  const url = new URL(`${userHost}/api/player/event/${eventKey}/login/comdi/check_email`);
  setRequestToken(eventKey);
  try {
    const response = await fetch(url, {
      ...fetchOptions,
      method: 'POST',
      body: formData,
    });
    saveRequestToken(response, eventKey);
    return response;
  } catch (error) {
    return error;
  }
};

export const registerByEmail = async (email, surname, name, patronymic, eventKey) => {
  const formData = new FormData();
  formData.append('email', email);
  formData.append('surname', surname);
  formData.append('name', name);
  formData.append('patronymic', patronymic);
  formData.append('eventKey', eventKey);
  formData.append('locale', local.getItem(`userCurrentLocale${eventKey}`));

  // const url = new URL(`${userHost}/broadcast/api/client/account/comdi/registration.json`);
  const url = new URL(`${userHost}/api/player/event/${eventKey}/login/comdi/registration`);
  setRequestToken(eventKey);
  try {
    const response = await fetch(url, {
      ...fetchOptions,
      method: 'POST',
      body: formData,
    });
    saveRequestToken(response, eventKey);
    return response;
  } catch (error) {
    return error;
  }
};

export const restorePassword = async (email, eventKey) => {
  const formData = new FormData();
  formData.append('email', email);
  formData.append('locale', local.getItem(`userCurrentLocale${eventKey}`));

  // const url = new URL(`${userHost}/broadcast/api/client/account/comdi/restore.json`);
  const url = new URL(`${userHost}/api/player/event/${eventKey}/login/comdi/restore`);
  
  setRequestToken(eventKey);
  try {
    const response = await fetch(url, {
      ...fetchOptions,
      method: 'POST',
      body: formData,
    });
    saveRequestToken(response, eventKey);
    return await response.json();
  } catch (error) {
    return error;
  }
};

export const authByEmail = async (email, code, eventKey) => {
  const formData = new FormData();
  formData.append('email', email);
  formData.append('code', code);
  formData.append('locale', local.getItem(`userCurrentLocale${eventKey}`));

  // const url = new URL(`${userHost}/broadcast/api/client/account/comdi.json`);
  const url = new URL(`${userHost}/api/player/event/${eventKey}/login/comdi`);
  
  setRequestToken(eventKey);
  try {
    const response = await fetch(url, {
      ...fetchOptions,
      method: 'POST',
      body: formData,
    });
    saveRequestToken(response, eventKey);
    return await response;
  } catch (error) {
    return error;
  }
};

export const userLogout = async (eventKey) => {
  // const url = new URL(`${userHost}/broadcast/api/client.json`);
  const url = new URL(`${userHost}/api/player/event/${eventKey}/logout`);
  
  setRequestToken(eventKey);
  try {
    const response = await fetch(url, {
      ...fetchOptions,
      method: 'POST',
    });
    // saveRequestToken(response, eventKey);
    local.removeItem(tokenStorageKey(eventKey));
    return await response;
  } catch (error) {
    return error;
  }
};

export const registerToEvent = async (registrationFields, eventKey) => {
  const formData = new FormData();
  formData.append('eventKey', eventKey);
  formData.append('locale', local.getItem(`userCurrentLocale${eventKey}`));
  Object.keys(registrationFields).forEach((key) => {
    if (registrationFields[key]) formData.append(key, registrationFields[key]);
  });

  // const url = new URL(`${userHost}/broadcast/api/client/registration.json`);
  const url = new URL(`${userHost}/api/player/client/registration`);
  
  setRequestToken(eventKey);
  try {
    const response = await fetch(url, {
      ...fetchOptions,
      method: 'POST',
      body: formData,
    });
    saveRequestToken(response, eventKey);
    return await response;
  } catch (error) {
    return error;
  }
};

export const loginAdmin = async (login, password) => {
  const url = new URL(`${adminHost}/construct_api/admin/auth/login`);
  try {
    return await fetch(url, {
      ...fetchOptions,
      method: 'POST',
      body: JSON.stringify({ login, password }),
    });
  } catch (error) {
    return error;
  }
};

export const getHomePageContent = async (eventKey) => {
  if (eventKey) {
    try {
      const response = await fetch(`${userHost}/watch/${eventKey}/data.json`, {
        ...fetchOptions,
        headers: { 'cache-control': 'no-cache' },
      });
      return await response.json();
    } catch (error) {
      throw error;
    }
  }
  return false;
};

// export function getHomePageContent(eventKey) {
//   return new Promise(function (resolve, reject) {
//     if (eventKey) {
//       const xhr = new XMLHttpRequest();
//       xhr.open('GET', `${userHost}/watch/${eventKey}/data.json`);
//       xhr.setRequestHeader('Content-Type', 'application/json');
//       xhr.setRequestHeader('cache-control', 'no-cache');
//       xhr.responseType = 'json';
//       xhr.onload = function () {
//         if (this.status >= 200 && this.status < 300) {
//           resolve(this.response);
//         } else {
//           reject({
//             status: this.status,
//             statusText: this.statusText,
//           });
//         }
//       };
//       xhr.onerror = function () {
//         reject({
//           status: this.status,
//           statusText: this.statusText,
//         });
//       };
//       xhr.send();
//     }
//   });
// }

export const getNewsPageContent = async (eventKey, pageId) => {
  if (eventKey && pageId) {
    const url = new URL(`${userHost}/watch/${eventKey}/sp/${pageId}/data.json`);
    try {
      const response = await fetch(url, fetchOptions);
      return await response.json();
    } catch (error) {
      return error;
    }
  }
  return false;
};

export const savePreloadertSettings = async (eventKey, styles) => {
  if (eventKey) {
    const url = new URL(`${adminHost}/construct_api/${eventKey}/preloader_css`);
    try {
      const response = await fetch(url, {
        ...fetchOptions,
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'text/css',
        },
        // body: { styles, eventKey },
        body: styles,
      });
      return await response.json();
    } catch (error) {
      return error;
    }
  }
  return false;
};

export const saveFrontSettings = async (eventKey, settings) => {
  if (eventKey) {
    const url = new URL(`${adminHost}/construct_api/${eventKey}/frontData`);
    try {
      const response = await fetch(url, {
        ...fetchOptions,
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          frontData: {
            ...settings,
            eventKey,
          },
        }),
      });
      return await response.json();
    } catch (error) {
      return error;
    }
  }
  return false;
};


export const sendQuestionMessage = async (eventKey, payload) => {
  if (eventKey) {
    const locale = local.getItem(`userCurrentLocale${eventKey}`) || 'ru';
    const data = {...payload, locale};

    try {
      const response = await fetch(`${adminHost}/construct_api/user_forms/${eventKey}`, {
        // ...fetchOptions,
        method: 'POST',
        mode: 'cors',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-client-access-token': local.getItem(tokenStorageKey(eventKey)),
        },
        body: JSON.stringify(data),
      });
      return await response;
    } catch (error) {
      return error;
    }
  }
  return false;
};

export const trackingUserEvent = async (eventKey, trackingKey) => {
  if (eventKey && trackingKey) {
    const key = encodeURIComponent('trackingKey')
    const value = encodeURIComponent(trackingKey)
    
    try {
      const response = await fetch(`/api/player/event/${eventKey}/client/tracking`, {
        // ...fetchOptions,
        method: 'POST',
        mode: 'cors',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          'x-client-access-token': local.getItem(tokenStorageKey(eventKey)),
        },
        body: `${key}=${value}`
      });
      return await response;
    } catch (error) {
      return error;
    }
  }
  return false;
};

export const getFontsList = async () => {
  const url = new URL(`${adminHost}/construct_api/fonts`);
  try {
    const response = await fetch(url, fetchOptions);
    return await response.json();
  } catch (error) {
    return error;
  }
};


export const getQuizList = async (eventKey, userIdOrEmail) => {
  const url = new URL(`${adminHost}/construct_api/quiz/list`);
  const data = {
    user: userIdOrEmail,
    event: eventKey,
  };
  
  try {
    const response = await fetch(url, {
      ...fetchOptions,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify(data),
    });

    return await response.json();
  } catch (error) {
    return error;
  } 
}


export const quizAnswerRequest = async (data) => {
  const url = new URL(`${adminHost}/construct_api/quiz/answer`);
  try {
    const response = await fetch(url, {
      ...fetchOptions,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify(data),
    });

    return await response.json();
  } catch (error) {
    return error;
  } 
};

export const loginByToken = async ({eventKey, token}) => {
  const url = new URL(`${userHost}/api/player/event/${eventKey}/login/accessToken`);
  url.search = new URLSearchParams({accessToken: token}).toString();

  try {
    const response = await fetch(url, {
      ...fetchOptions,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({accessToken: token}),
    });

    saveRequestToken(response, eventKey);

    return true;
  } catch (error) {
    console.error(error);
    
    return false;
  } 
};
